import { useState as d } from "react";
import { useTranslation as j } from "../../../i18n.mjs";
import { useFileActions as k } from "../../file-selector/hooks/use-file-actions.mjs";
import { useFileUploader as x } from "./use-file-uploader.mjs";
import { hashFile as D } from "../../../utils/hash-file.mjs";
const G = ({
  preLoadedFiles: p,
  source: f,
  fileManagerApiType: A,
  onChange: a
}) => {
  const { t: b } = j(), { createFileUploader: E } = x(A), { deleteFile: M } = k(), [O, c] = d([]), [u, F] = d([]), [g, n] = d({}), [U, m] = d([]), P = (r) => {
    const e = p == null ? void 0 : p.map((o) => o.id);
    return e == null ? void 0 : e.includes(r.id);
  }, S = () => u.map((e) => {
    const o = !P(e);
    return {
      file: { ...e, name: e.filename },
      disabled: U.includes(e.id),
      uploaded: o
    };
  }), v = () => Object.entries(g).map(([e, o]) => ({
    file: { ...o, id: e, name: o.file.name },
    progress: o.progress.isUploading ? o.progress.progress : void 0,
    uploaded: o.progress.isUploaded
  })), N = S(), _ = v(), y = async (r) => {
    try {
      m((e) => [...e, r]), await M({ id: r }), F((e) => {
        const o = e.filter((l) => l.id !== r);
        return a == null || a(o), o;
      });
    } catch (e) {
      throw e;
    } finally {
      m((e) => e.filter((o) => o !== r));
    }
  }, w = (r) => {
    g[r].cancelUpload(), n((e) => {
      const { [r]: o, ...l } = e;
      return l;
    });
  };
  return {
    waitingUploadFiles: O,
    setWaitingUploadFiles: c,
    removingFiles: U,
    uploadedFiles: u,
    setUploadedFiles: F,
    mappedUploadedFiles: N,
    mappedUploadingFiles: _,
    startUploading: async (r) => {
      const e = await D(r) + "_" + crypto.randomUUID(), l = E((t) => {
        n((s) => ({
          ...s,
          [e]: {
            ...s[e],
            progress: t
          }
        }));
      });
      c((t) => t.filter((s) => s.file !== r)), n((t) => ({
        ...t,
        [e]: {
          file: r,
          progress: l.progress.getState(),
          cancelUpload: l.cancelUpload
        }
      }));
      try {
        const t = await l.upload({
          file: r,
          source: f
        });
        if (t)
          return F((s) => {
            const i = [{ ...t, file: r }, ...s];
            return a == null || a(i), i;
          }), t;
      } catch (t) {
        const s = t instanceof Error ? t : new Error(b("file_manager.error"));
        throw c((i) => [{ file: r, error: s }, ...i]), t;
      } finally {
        n((t) => {
          const { [e]: s, ...i } = t;
          return i;
        });
      }
    },
    deleteUploadedOrUploadingFile: async (r) => {
      g[r] && await w(String(r)), u.find((l) => l.id === +r) && await y(Number(r));
    },
    deleteUploadedFile: y,
    deleteUploadingFile: w
  };
};
export {
  G as useFileUploaderManager
};
